import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import Swal from "sweetalert2";
import { Select, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { clear_auth, set_auth } from "../../reducers/Auth";
import UploadIcon from '../../assets/icons/import-icon-blue-light.svg'
import {withTourGuide} from "../guideComponent/withTourGuide";

export class Add_karyawan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prosesSimpan: false,
            isLoading: true,
            divisi: [],
            jabatan: [],
            lokasi: [],
            fileList: [],
            fileKtp: [],
            fileSelfie: [],
            fileIjazah: [],
            perusahaan_karyawan: '',
            foto_karyawan: '',
            foto_ktp: '',
            foto_selfie: '',
            foto_ijazah: '',
            nama_karyawan: '',
            no_induk_karyawan: '',
            gender_karyawan: 'Laki-laki',
            divisi_karyawan: '',
            jabatan_karyawan: '',
            lokasi_karyawan: null,
            email_karyawan: '',
            ttl_karyawan: '',
            join_date_karyawan: '',
            no_hp_karyawan: '',
            alamat_karyawan: '',
            no_npwp: '',
            no_bpjs: '',
        }
        this.handleChange = this.handleChange.bind(this)
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    loadJabatan() {
        let form = {}
        this.props.request("get_jabatan_perusahaan", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        isLoading: false,
                        jabatan: response.data
                    })
                }
            });
    }

    loadDivisi() {
        let form = {}
        this.props.request("get_divisi_perusahaan", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        isLoading: false,
                        divisi: response.data
                    })
                }
            });
    }

    loadLokasi() {
        let form = {}
        this.props.request("get_lokasi_perusahaan", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        lokasi: response.data,
                        lokasi_karyawan: null,
                    })
                }
            });
    }

    lokasiHandler = () => {
        if (this.state.lokasi_karyawan === null) {
            this.setState({
                lokasi_karyawan: ''
            })
        } else {
            this.setState({
                lokasi_karyawan: null
            })
        }
    }

    simpanKaryawan = () => {
        this.setState({
            prosesSimpan: true,
        })

        let form = {
            lokasi_karyawan: this.state.lokasi_karyawan,
            foto_karyawan: this.state.foto_karyawan,
            foto_selfie: this.state.foto_selfie,
            foto_ijazah: this.state.foto_ijazah,
            foto_ktp: this.state.foto_ktp,
            nama_karyawan: this.state.nama_karyawan,
            no_induk_karyawan: this.state.no_induk_karyawan,
            gender_karyawan: this.state.gender_karyawan,
            email_karyawan: this.state.email_karyawan,
            jabatan_karyawan: this.state.jabatan_karyawan,
            divisi_karyawan: this.state.divisi_karyawan,
            ttl_karyawan: this.state.ttl_karyawan,
            join_date_karyawan: this.state.join_date_karyawan,
            no_hp_karyawan: this.state.no_hp_karyawan,
            alamat_karyawan: this.state.alamat_karyawan,
            no_npwp: this.state.no_npwp,
            no_bpjs: this.state.no_bpjs,
        }

        this.props.request("karyawan/add_karyawan", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.success,
                        icon: 'success'
                    })
                    this.props.history.push('/karyawan/list-karyawan/0')
                } else if (response && response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.failed,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    prosesSimpan: false,
                })
            });
    }

    cekMasterData() {
        if (this.props.user.perusahaan.divisi === null || this.props.user.perusahaan.jabatan.length < 1 || this.props.user.perusahaan.lokasi.length < 1) {
            Swal.fire({
                title: 'Peringatan!',
                text: 'Anda harus menambahkan Seluruh Master Data terlebih dahulu',
                icon: 'warning',
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.props.history.push('/karyawan/shift')
                    }
                })
        }
    }

    componentDidMount() {
        this.cekMasterData()
        this.loadLokasi()
        this.loadDivisi()
        this.loadJabatan()
    }

    render() {
        const { Option } = Select;
        const {divisi, jabatan} = this.state
        return (
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Tambah Karyawan - Presensi</title>
                    <meta name="description" content="Detail Absensi" />
                </Helmet>
                <Breadcrumb title="Tambah Karyawan" parent="Karyawan" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <form className="needs-validation user-add" noValidate="">
                                        <div className='row mb-2'>
                                            <div className='col-md-6'>
                                                <h4>Detail Karyawan</h4>
                                            </div>
                                            <div className='col-md-6 d-flex justify-content-end'>
                                                <a className='btn btn-outline-secondary mr-2 text-capitalize' href="list-karyawan/0">Batalkan</a>
                                                {this.state.prosesSimpan === false ?
                                                    <button type="button" className="btn btn-primary text-capitalize"
                                                            onClick={this.simpanKaryawan}><i className="fa fa-floppy-o"></i> Simpan</button>
                                                    :
                                                    <button type="button" className="btn btn-primary text-capitalize"><i className="fa fa-refresh fa-spin"></i> Loading</button>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row col-md-12">
                                            <div
                                                className="col-lg-3 col-md-6"
                                                onPointerEnter={(e) => {
                                                    this.triggerGuideOnce(e, {
                                                        key: "fotoKaryawanAdd",
                                                        title: "Foto Karyawan",
                                                        content: "Upload foto profil karyawan. Foto akan otomatis dipotong sesuai ukuran yang ditentukan."
                                                    });
                                                }}>
                                                <ImgCrop rotate width={750} height={1000}>
                                                    <Upload customRequest={({ file, onSuccess }) => {
                                                        setTimeout(() => { onSuccess("ok"); }, 0);
                                                    }}
                                                            listType="picture-card"
                                                            fileList={this.state.fileList}
                                                            className="antd-upload-custom"
                                                            onRemove={() => { this.setState({ foto_karyawan: null }) }}
                                                            onChange={(file) => {
                                                                this.setState({ fileList: file.fileList })
                                                                if (file.fileList.length > 0) {
                                                                    let files = file.file.originFileObj
                                                                    let reader = new FileReader()
                                                                    reader.readAsDataURL(files)
                                                                    reader.onloadend = () => {
                                                                        this.setState({ foto_karyawan: { name: file.file.name, file: reader.result } })
                                                                    }
                                                                } else {
                                                                    this.setState({ foto_karyawan: [] })
                                                                }
                                                            }}
                                                    >
                                                        {this.state.fileList.length >= 1 ? null :
                                                            <div className="p-2 d-flex align-items-center justify-content-center flex-column" style={{height: "167px"}}>
                                                                <span><img src={UploadIcon} style={{height: "24px", width: "24px"}} /></span>
                                                                <p className="ant-upload-text mb-3" style={{fontSize: "12px", fontWeight: 400, lineHeight: "16px", marginTop: "6px"}}>Upload foto karyawan</p>
                                                                <a className="btn btn-outline-custom tambah-karyawan">Cari Gambar</a>
                                                            </div>
                                                        }
                                                    </Upload>
                                                </ImgCrop>
                                            </div>
                                            <div
                                                className="col-lg-3 col-md-6"
                                                onPointerEnter={(e) => {
                                                    this.triggerGuideOnce(e, {
                                                        key: "fotoSelfieAdd",
                                                        title: "Foto Selfie Karyawan",
                                                        content: "Upload foto selfie karyawan yang akan digunakan sebagai referensi pengenalan wajah saat presensi."
                                                    });
                                                }}>
                                                <ImgCrop rotate width={550} height={860}>
                                                    <Upload customRequest={({ file, onSuccess }) => {
                                                        setTimeout(() => { onSuccess("ok"); }, 0);
                                                    }}
                                                            listType="picture-card"
                                                            fileList={this.state.fileSelfie}
                                                            className="antd-upload-custom"
                                                            onRemove={() => { this.setState({ foto_selfie: null }) }}
                                                            onChange={(file) => {
                                                                this.setState({ fileSelfie: file.fileList })
                                                                if (file.fileList.length > 0) {
                                                                    let files = file.file.originFileObj
                                                                    let reader = new FileReader()
                                                                    reader.readAsDataURL(files)
                                                                    reader.onloadend = () => {
                                                                        this.setState({ foto_selfie: { name: file.file.name, file: reader.result } })
                                                                    }
                                                                } else {
                                                                    this.setState({ foto_selfie: [] })
                                                                }
                                                            }}
                                                    >
                                                        {this.state.fileSelfie.length >= 1 ? null :
                                                            <div className="p-2 d-flex flex-column align-items-center justify-content-center" style={{height: "167px"}}>
                                                                <span><img src={UploadIcon} style={{height: "24px", width: "24px"}} /></span>
                                                                <p className="ant-upload-text mb-3" style={{fontSize: "12px", fontWeight: 400, lineHeight: "16px", marginTop: "6px"}}>Upload foto selfie karyawan</p>
                                                                <a className="btn btn-outline-custom tambah-karyawan">Cari Gambar</a>
                                                            </div>
                                                        }
                                                    </Upload>
                                                </ImgCrop>
                                            </div>
                                            <div
                                                className="col-lg-3 col-md-6"
                                                onPointerEnter={(e) => {
                                                    this.triggerGuideOnce(e, {
                                                        key: "fotoKtpAdd",
                                                        title: "Foto KTP Karyawan",
                                                        content: "Upload foto KTP karyawan sebagai dokumen identitas resmi."
                                                    });
                                                }}>
                                                <ImgCrop rotate width={960} height={480}>
                                                    <Upload customRequest={({ file, onSuccess }) => {
                                                        setTimeout(() => { onSuccess("ok"); }, 0);
                                                    }}
                                                            listType="picture-card"
                                                            fileList={this.state.fileKtp}
                                                            className="antd-upload-custom"
                                                            onRemove={() => { this.setState({ foto_ktp: null }) }}
                                                            onChange={(file) => {
                                                                this.setState({ fileKtp: file.fileList })
                                                                if (file.fileList.length > 0) {
                                                                    let files = file.file.originFileObj
                                                                    let reader = new FileReader()
                                                                    reader.readAsDataURL(files)
                                                                    reader.onloadend = () => {
                                                                        this.setState({ foto_ktp: { name: file.file.name, file: reader.result } })
                                                                    }
                                                                } else {
                                                                    this.setState({ foto_ktp: [] })
                                                                }
                                                            }}
                                                    >
                                                        {this.state.fileKtp.length >= 1 ? null :
                                                            <div className="p-2 d-flex flex-column align-items-center justify-content-center" style={{height: "167px"}}>
                                                                <span><img src={UploadIcon} style={{height: "24px", width: "24px"}} /></span>
                                                                <p className="ant-upload-text mb-3" style={{fontSize: "12px", fontWeight: 400, lineHeight: "16px", marginTop: "6px"}}>Upload foto KTP karyawan</p>
                                                                <a className="btn btn-outline-custom tambah-karyawan">Cari Gambar</a>
                                                            </div>
                                                        }
                                                    </Upload>
                                                </ImgCrop>
                                            </div>
                                            <div
                                                className="col-lg-3 col-md-6"
                                                onPointerEnter={(e) => {
                                                    this.triggerGuideOnce(e, {
                                                        key: "fotoIjazahAdd",
                                                        title: "Foto Ijazah & Sertifikat",
                                                        content: "Upload foto ijazah atau sertifikat pendidikan karyawan sebagai dokumen pendukung."
                                                    });
                                                }}>
                                                <ImgCrop rotate width={550} height={860}>
                                                    <Upload customRequest={({ file, onSuccess }) => {
                                                        setTimeout(() => { onSuccess("ok"); }, 0);
                                                    }}
                                                            listType="picture-card"
                                                            fileList={this.state.fileIjazah}
                                                            className="antd-upload-custom"
                                                            onRemove={() => { this.setState({ foto_ijazah: null }) }}
                                                            onChange={(file) => {
                                                                this.setState({ fileIjazah: file.fileList })
                                                                if (file.fileList.length > 0) {
                                                                    let files = file.file.originFileObj
                                                                    let reader = new FileReader()
                                                                    reader.readAsDataURL(files)
                                                                    reader.onloadend = () => {
                                                                        this.setState({ foto_ijazah: { name: file.file.name, file: reader.result } })
                                                                    }
                                                                } else {
                                                                    this.setState({ foto_ijazah: [] })
                                                                }
                                                            }}
                                                    >
                                                        {this.state.fileIjazah.length >= 1 ? null :
                                                            <div className="p-2 d-flex align-items-center justify-content-center flex-column" style={{height: "167px"}}>
                                                                <span><img src={UploadIcon} style={{height: "24px", width: "24px"}} /></span>
                                                                <p className="ant-upload-text mb-3" style={{fontSize: "12px", fontWeight: 400, lineHeight: "16px", marginTop: "6px"}}>Upload foto ijazah dan sertifikat</p>
                                                                <a className="btn btn-outline-custom tambah-karyawan">Cari Gambar</a>
                                                            </div>
                                                        }
                                                    </Upload>
                                                </ImgCrop>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Nama Karyawan</label>
                                                    <input
                                                        style={{ fontSize: "12px" }}
                                                        name="nama_karyawan"
                                                        className="form-control"
                                                        placeholder="Nama Karyawan..."
                                                        type="text"
                                                        required=""
                                                        onChange={this.handleChange}
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "namaKaryawanAdd",
                                                                title: "Nama Karyawan",
                                                                content: "Masukkan nama lengkap karyawan sesuai dengan identitas resmi."
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Nomor Induk Karyawan (Opsional)</label>
                                                    <input
                                                        style={{ fontSize: "12px" }}
                                                        name="no_induk_karyawan"
                                                        className="form-control"
                                                        placeholder="Nomor Induk Karyawan..."
                                                        type="text"
                                                        required=""
                                                        onChange={this.handleChange}
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "noIndukKaryawanAdd",
                                                                title: "Nomor Induk Karyawan",
                                                                content: "Masukkan nomor induk karyawan jika tersedia. Field ini bersifat opsional."
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Email</label>
                                                    <input
                                                        style={{ fontSize: "12px" }}
                                                        name="email_karyawan"
                                                        className="form-control"
                                                        placeholder="Email Karyawan..."
                                                        type="email"
                                                        required=""
                                                        onChange={this.handleChange}
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "emailKaryawanAdd",
                                                                title: "Email Karyawan",
                                                                content: "Masukkan alamat email aktif karyawan. Email ini akan digunakan untuk login ke aplikasi."
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">No. Handphone</label>
                                                    <input
                                                        style={{ fontSize: "12px" }}
                                                        name="no_hp_karyawan"
                                                        className="form-control"
                                                        type="number"
                                                        required=""
                                                        placeholder="No. HP Karyawan..."
                                                        onChange={this.handleChange}
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "noHpKaryawanAdd",
                                                                title: "No. Handphone",
                                                                content: "Masukkan nomor handphone aktif karyawan untuk keperluan komunikasi."
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Alamat</label>
                                                    <textarea
                                                        style={{ fontSize: "12px" }}
                                                        name="alamat_karyawan"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Alamat Karyawan..."
                                                        onChange={this.handleChange}
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "alamatKaryawanAdd",
                                                                title: "Alamat",
                                                                content: "Masukkan alamat lengkap tempat tinggal karyawan."
                                                            });
                                                        }}>
                                    </textarea>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Nomor Pokok Wajib Pajak (Opsional)</label>
                                                    <input
                                                        maxLength={16}
                                                        style={{ fontSize: "12px" }}
                                                        name="no_npwp"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Nomor Pokok Wajib Pajak..."
                                                        onChange={this.handleChange}
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "npwpKaryawanAdd",
                                                                title: "NPWP",
                                                                content: "Masukkan Nomor Pokok Wajib Pajak karyawan jika tersedia. Field ini bersifat opsional."
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">No. BPJS (Opsional)</label>
                                                    <input
                                                        maxLength={16}
                                                        style={{ fontSize: "12px" }}
                                                        name="no_bpjs"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="No. BPJS..."
                                                        onChange={this.handleChange}
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "bpjsKaryawanAdd",
                                                                title: "No. BPJS",
                                                                content: "Masukkan nomor BPJS karyawan jika tersedia. Field ini bersifat opsional."
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Tanggal Lahir</label>
                                                            <input
                                                                style={{ fontSize: "12px" }}
                                                                name="ttl_karyawan"
                                                                className="form-control"
                                                                onChange={this.handleChange}
                                                                type="date"
                                                                required=""
                                                                onPointerEnter={(e) => {
                                                                    this.triggerGuideOnce(e, {
                                                                        key: "tanggalLahirKaryawanAdd",
                                                                        title: "Tanggal Lahir",
                                                                        content: "Masukkan tanggal lahir karyawan sesuai identitas resmi."
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div
                                                            className="form-group"
                                                            onPointerEnter={(e) => {
                                                                this.triggerGuideOnce(e, {
                                                                    key: "jenisKelaminKaryawanAdd",
                                                                    title: "Jenis Kelamin",
                                                                    content: "Pilih jenis kelamin karyawan dengan mengklik salah satu pilihan yang tersedia."
                                                                });
                                                            }}>
                                                            <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Jenis Kelamin Karyawan</label>
                                                            <div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" checked={this.state.gender_karyawan === "Laki-laki"} onClick={(e) => this.setState({ gender_karyawan: e.target.value })} name="inlineRadioOptions" id="inlineRadio1" value="Laki-laki" />
                                                                    <label className="form-check-label" style={{ fontSize: "12px" }} htmlFor="inlineRadio1">Laki-Laki</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" onClick={(e) => this.setState({ gender_karyawan: e.target.value })} checked={this.state.gender_karyawan === "Perempuan"} value="Perempuan" />
                                                                    <label className="form-check-label" style={{ fontSize: "12px" }} htmlFor="inlineRadio2">Perempuan</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Tanggal Mulai Kerja Karyawan</label>
                                                    <input
                                                        style={{ fontSize: "12px" }}
                                                        name="join_date_karyawan"
                                                        className="form-control"
                                                        onChange={this.handleChange}
                                                        type="date"
                                                        required=""
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "joinDateKaryawanAdd",
                                                                title: "Tanggal Mulai Kerja",
                                                                content: "Masukkan tanggal pertama karyawan mulai bekerja di perusahaan."
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Divisi Karyawan</label>
                                                    <select
                                                        style={{ fontSize: "12px" }}
                                                        name="divisi_karyawan"
                                                        className="form-control"
                                                        onChange={this.handleChange}
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "divisiKaryawanAdd",
                                                                title: "Divisi Karyawan",
                                                                content: "Pilih divisi tempat karyawan akan ditempatkan."
                                                            });
                                                        }}>
                                                        <option style={{ fontSize: "12px" }}>Pilih Divisi</option>
                                                        {divisi.map((item, index) => (
                                                            <option style={{ fontSize: "12px" }} value={item.divisi_id} key={index}>{item.divisi_name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Jabatan Karyawan</label>
                                                    <select
                                                        style={{ fontSize: "12px" }}
                                                        name="jabatan_karyawan"
                                                        className="form-control"
                                                        onChange={this.handleChange}
                                                        onPointerEnter={(e) => {
                                                            this.triggerGuideOnce(e, {
                                                                key: "jabatanKaryawanAdd",
                                                                title: "Jabatan Karyawan",
                                                                content: "Pilih jabatan yang sesuai dengan posisi karyawan di perusahaan."
                                                            });
                                                        }}>
                                                        <option style={{ fontSize: "12px" }}>Pilih Jabatan</option>
                                                        {jabatan.map((item, index) => (
                                                            <option style={{ fontSize: "12px" }} value={item.jabatan_id} key={index}>{item.jabatan_nama}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div
                                                    className="form-group"
                                                    onPointerEnter={(e) => {
                                                        this.triggerGuideOnce(e, {
                                                            key: "lokasiAbsenKaryawanAdd",
                                                            title: "Lokasi Absen Karyawan",
                                                            content: "Pilih lokasi presensi karyawan. Centang 'Semua Lokasi Perusahaan' jika karyawan bisa presensi di semua lokasi, atau pilih lokasi spesifik."
                                                        });
                                                    }}>
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Lokasi Absen Karyawan</label>
                                                    <div>
                                                        <label style={{ fontSize: "12px" }}>
                                                            <input
                                                                style={{ fontSize: "12px" }}
                                                                type="checkbox"
                                                                checked={this.state.lokasi_karyawan === null}
                                                                onChange={() => this.lokasiHandler()}
                                                            />
                                                            &nbsp;Semua Lokasi Perusahaan
                                                        </label>
                                                        {this.state.lokasi_karyawan !== null &&
                                                            <Select
                                                                name="lokasi_karyawan"
                                                                style={{ width: '100%' }}
                                                                mode={"multiple"}
                                                                placeholder="Pilih Lokasi"
                                                                filterOption={(input, option) =>
                                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                onChange={(event) => {
                                                                    this.setState({ lokasi_karyawan: event })
                                                                }}>
                                                                {this.state.lokasi.map((item, index) => (
                                                                    <Option key={item.lokasi_id}>{item.lokasi_nama}</Option>
                                                                ))}
                                                            </Select>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token,
    jabatan: state.Filter._jabatan,
    divisi: state.Filter._divisi
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withTourGuide(Add_karyawan));
